var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback"},[_c('app-mark',{staticClass:"callback-mark",attrs:{"size":34}}),(!_vm.error)?_c('p',{staticClass:"callback-note"},[_vm._v("Signing you in…")]):[_c('p',{staticClass:"callback-error"},[_vm._v(_vm._s(_vm.error))]),_c('router-link',{staticClass:"callback-link",attrs:{"to":"/"}},[_vm._v("Back to today’s puzzle")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }